import { render, staticRenderFns } from "./DefaultStatisticsCounters.vue?vue&type=template&id=e5ae38b6&scoped=true"
import script from "./DefaultStatisticsCounters.ts?vue&type=script&lang=ts&external"
export * from "./DefaultStatisticsCounters.ts?vue&type=script&lang=ts&external"
import style0 from "./DefaultStatisticsCounters.scss?vue&type=style&index=0&id=e5ae38b6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ae38b6",
  null
  
)

export default component.exports